export default {
  Farm: {
    header: {
      create_farm: 'Cadastrar fazenda',
      action_unauthorized: 'Você não tem permissão para realizar essa ação.',
      field_text_suggestion:
        'Talvez este seja um bom momento para criar os talhões de sua fazenda.',
      creation_question: 'Criar talhões?',
      farms: 'Fazendas',
    },
    import_fields_kml_card: {
      insufficient_coordinates: 'Talhão {0} está com as coordenadas erradas',
      insufficient_polygons: 'Quantidade insuficiente de polígonos',
      warning:
        'Formato do KML não conhecido ou formatado sem as especificações do sistema',
      no_field_latitude: 'O talhão {0} não possui latitudes',
      no_field_longitude: 'O talhão {0} não possui longitude',
    },
    farm_card: {
      delete_farm_successfully: 'Fazenda excluída com sucesso',
      function_temporarily_unavailable: 'Função temporariamente indisponível',
      delete_farm_warning:
        'Ao excluir a fazenda, os programas associados serão perdidos. Esta operação é irreversível.',
      which_channel_to_contact:
        'Com qual canal você gostaria de entrar em contato?',
      excluir: 'Excluir',
      fields: 'Talhões',
      she_disabled: 'Desabilitada',
      disable_farm_successfully: 'Fazenda desabilitada com sucesso.',
      enable_farm_successfully: 'Fazenda habilitada com sucesso.',
    },
    add_farm_modal: {
      edit_farm: 'Edição de fazenda',
      add_farm: 'Cadastro de fazenda',
      save_error: 'Erro ao salvar fazendas.',
      loading_error: 'Erro ao carregar fazendas.',
      city_error: 'Erro ao carregar municipios.',
      state_error: 'Erro ao carregar estados.',
      warning_create_farm:
        'Ao criar uma fazenda, você será redirecionado para ela',
      farm_name: 'Nome da fazenda',
      type_here: 'Digite aqui',
      country: 'País',
      select: 'Selecione',
      states: 'Estados',
      cities: 'Municipios',
      required_price: 'Preço obrigatório',
    },
    fields_item_modal: {
      delete_field_warning:
        'Esta é uma operação irreversível. Você quer excluir o talhão?',
      enable_farm_error:
        'Você não pode mais habilitar fazendas nem talhões. Caso deseje habilitar mesmo assim, entre em contato com nosso time de suporte.',
      he_disabled: 'Desabilitado',
      disable_field_successfully: 'Talhão desabilitado com sucesso.',
      enable_field_successfully: 'Talhão habilitado com sucesso.',
    },
    fields_modal: {
      add_fields: 'Cadastro de talhões',
      total: 'Total',
      done: 'Feito',
      map_new_fields: 'Mapeie novos talhões',
      add_field_description:
        'Você pode adicionar talhões a partir de arquivos KML, ou marcando a área do talhão.',
      kml_format: 'O arquivo KML deve estar no formato Google.',
      load_kml: 'Carregar KML',
      or: 'ou',
    },
    maps_modal: {
      field_name: 'Nome do talhão',
      remove_point: 'Remover ponto',
      search_latitude: 'Buscar latitude',
      search_longitude: 'Buscar longitude',
      save_field_warning:
        'Para salvar o talhão, adicione pelo menos 3 pontos no mapa!',
      invalid_geometry:
        'Cuidado! O desenho do talhão deve representar uma figura geométrica válida. Faça o ajuste no mapa para conseguir concluir.',
      required_field: 'Campo obrigatório',
      field_map: 'Mapa do talhão',
      save: 'Salvar',
      action_unauthorized: 'Você não tem permissão para realizar essa ação',
    },
    field_saved: 'Talhão salvo com sucesso',
    msg_whatsapp_limit_enable_exceeded:
      '?text=Ol%C3%A1!+Gostaria+de+auxilio+pois+n%C3%A3o+consigo+mais+habilitar+fazendas+e+talh%C3%B5es. Utilizo+a+conta {0}.',
    edit: 'Editar',
    enable: 'Habilitar',
    disable: 'Desabilitar',
    enable_field_warning:
      'Ao desabilitar o talhão, você não pode criar novas semeaduras, deseja continuar mesmo assim?',
    disable_farm_warning:
      'Ao desabilitar o talhão, você não pode criar novas semeaduras, deseja continuar mesmo assim ?',
    get_in_touch: 'Entrar em contato',
    area: 'Área',
    add: 'Adicionar',
  },
}
